import React, { useState, useEffect } from "react";
import emailjs from 'emailjs-com';
import Header from "../components/Header";
import Footer from "../components/Footer";
import bgEntreprise from "../assets/Service-entreprise.jpg";
import "./Entreprises.css";

export default function Devis() {
  const [formData, setFormData] = useState({
    company: "",
    jobTitle: "",
    firstName: "",
    lastName: "",
    address: "",
    houseNumber: "",
    houseAddition: "",
    postalCode: "",
    location: "",
    email: "",
    phone: "",
    services: [],
    propertyTypes: [],
    area: "",
    frequency: "",
    days: [],
    timeSlot: "",
    hours: [],
    additionalDetails: "",
    howFound: "",
    keyword: "",
    acceptMessages: false
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Initialiser EmailJS
  useEffect(() => {
    emailjs.init("9F85Ev10EWr3d_J2r");
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      if (name.startsWith("services_")) {
        setFormData(prev => ({
          ...prev,
          services: checked 
            ? [...prev.services, value]
            : prev.services.filter(s => s !== value)
        }));
      } else if (name.startsWith("property_")) {
        setFormData(prev => ({
          ...prev,
          propertyTypes: checked
            ? [...prev.propertyTypes, value]
            : prev.propertyTypes.filter(p => p !== value)
        }));
      } else if (name.startsWith("days_")) {
        setFormData(prev => ({
          ...prev,
          days: checked
            ? [...prev.days, value]
            : prev.days.filter(d => d !== value)
        }));
      } else if (name.startsWith("hours_")) {
        setFormData(prev => ({
          ...prev,
          hours: checked
            ? [...prev.hours, value]
            : prev.hours.filter(h => h !== value)
        }));
      } else if (name === "acceptMessages") {
        setFormData(prev => ({
          ...prev,
          acceptMessages: checked
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // Formater les données pour l'email
      const templateParams = {
        to_email: "info@directschoon-diensten.nl",
        from_email: formData.email,
        company: formData.company,
        jobTitle: formData.jobTitle,
        firstName: formData.firstName,
        lastName: formData.lastName,
        address: formData.address,
        houseNumber: formData.houseNumber,
        houseAddition: formData.houseAddition,
        postalCode: formData.postalCode,
        location: formData.location,
        phone: formData.phone,
        services: formData.services.join(", "),
        propertyTypes: formData.propertyTypes.join(", "),
        area: formData.area,
        frequency: formData.frequency,
        days: formData.days.join(", "),
        timeSlot: formData.timeSlot,
        hours: formData.hours.join(", "),
        additionalDetails: formData.additionalDetails,
        howFound: formData.howFound,
        keyword: formData.keyword,
        acceptMessages: formData.acceptMessages ? "Oui" : "Non"
      };

      // Envoyer l'email avec EmailJS
      await emailjs.send(
        "service_zc8xhmm",
        "template_guovmnk",
        templateParams
      );

      setMessage("✅ Votre demande de devis a été envoyée avec succès !");
      setShowSuccessModal(true);
      // Réinitialiser le formulaire
      setFormData({
        company: "",
        jobTitle: "",
        firstName: "",
        lastName: "",
        address: "",
        houseNumber: "",
        houseAddition: "",
        postalCode: "",
        location: "",
        email: "",
        phone: "",
        services: [],
        propertyTypes: [],
        area: "",
        frequency: "",
        days: [],
        timeSlot: "",
        hours: [],
        additionalDetails: "",
        howFound: "",
        keyword: "",
        acceptMessages: false
      });
    } catch (error) {
      console.error("Fout:", error);
      setMessage("❌ Fout bij het verzenden. Probeer het opnieuw.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {/* === HERO AVEC HEADER === */}
      <div
        className="hero-entreprises"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(0, 195, 300, 0.70),
              rgba(0, 175, 200, 0.75)
            ),
            url(${bgEntreprise})
          `,
        }}
      >
        <Header />
        <div className="hero-title">
          <h1>Gratis schoonmaakofferte aanvragen</h1>
        </div>
      </div>

      {/* === CONTENU DE LA PAGE === */}
      <div className="entreprises-content" style={{ display: "block", paddingLeft: "2rem", paddingRight: "2rem" }}>
        <div style={{ maxWidth: "1200px", marginLeft: "auto", marginRight: "auto" }}>
          <p style={{ color: "#666", marginBottom: "2rem" }}>
            Bedankt voor uw interesse in onze dienstverlening.
          </p>

          <p style={{ color: "#666", marginBottom: "1rem" }}>
            Met onderstaande vragen krijgen wij een goed beeld van uw locatie en schoonmaakwensen. Op basis hiervan beoordelen wij uw aanvraag en nemen wij contact met u op voor de vervolgstappen.
          </p>

          <p style={{ color: "#666", marginBottom: "1rem" }}>
            Wilt u liever direct iemand spreken? Bel ons op <strong>06 41 41 61 69</strong>Wij zijn bereikbaar op werkdagen van <strong> 09:00 tot 17:00 uur</strong>.
          </p>

          <p style={{ color: "#666", marginBottom: "2rem" }}>
            Afhankelijk van de informatie plannen wij een telefonisch intakegesprek of een locatiebezoek in.
          </p>

          <p style={{ color: "#666", marginBottom: "2rem", fontStyle: "italic" }}>
            Onderstaand formulier is bedoeld voor Schoonmaak van (zakelijke) ruimtes en objecten 
Bent u particulier en wilt u een grondige schoonmaak aanvragen? <br/>
            <a href="#" style={{ color: "#007bff" }}>Klik dan hier : Grondige Schoonmaak Aanvraag voor Particulieren</a>
          </p>

          <form className="devis-form" style={{ marginTop: "2rem" }} onSubmit={handleSubmit}>
            {message && (
              <div style={{ 
                padding: "1rem", 
                marginBottom: "1.5rem", 
                borderRadius: "4px",
                backgroundColor: message.includes("✅") ? "#d4edda" : "#f8d7da",
                color: message.includes("✅") ? "#155724" : "#721c24",
                border: `1px solid ${message.includes("✅") ? "#c3e6cb" : "#f5c6cb"}`
              }}>
                {message}
              </div>
            )}
            {/* Ligne 1 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold" }}>Bedrijfsnaam <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="company" value={formData.company} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Functietitel</label>
                <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
            </div>

            {/* Ligne 2 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold" }}>Voornaam <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Achternaam <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="lastName" value={formData.lastName} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
            </div>

            {/* Ligne 3 - Adresse */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 0.5fr 1fr", gap: "1rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold" }}>Adres <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="address" value={formData.address} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Huisnummer <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="houseNumber" value={formData.houseNumber} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Huisnummer toevoeging</label>
                <input type="text" name="houseAddition" value={formData.houseAddition} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
            </div>

            {/* Ligne 4 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold" }}>Postcode <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="postalCode" value={formData.postalCode} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Plaats <span style={{ color: "red" }}>*</span></label>
                <input type="text" name="location" value={formData.location} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
            </div>

            {/* Ligne 5 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "2rem" }}>
              <div>
                <label style={{ fontWeight: "bold" }}>E-mail <span style={{ color: "red" }}>*</span></label>
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Telefoonnummer <span style={{ color: "red" }}>*</span></label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", marginTop: "0.5rem" }} />
              </div>
            </div>

            {/* Services souhaités */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Welke dienst wilt u aanvragen? <span style={{ color: "red" }}>*</span></label>
              <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Meerdere keuzes mogelijk</p>
              <div>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="services_1" value="entretien de nettoyage" checked={formData.services.includes("entretien de nettoyage")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Schoonmaakonderhoud
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="services_2" value="Nettoyage de vitres (entreprise)" checked={formData.services.includes("Nettoyage de vitres (entreprise)")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Glasbewassing (zakelijk)

                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="services_3" value="Livraison ou nettoyage final (entreprise)" checked={formData.services.includes("Livraison ou nettoyage final (entreprise)")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Opleverings- of eindschoonmaak (zakelijk)
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="services_4" value="Entretien spécialisé" checked={formData.services.includes("Entretien spécialisé")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Specialistisch onderhoud - Bijvoorbeeld vloeronderhoud, tapijtreiniging, dieptereiniging of extra hygiëneschoonmaak
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="services_5" value="Encore exploratoire / services multiples" checked={formData.services.includes("Encore exploratoire / services multiples")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Nog oriënterend / meerdere diensten
                </label>
              </div>
            </div>

            {/* Type de propriété ou d'emplacement */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Type pand of locatie <span style={{ color: "red" }}>*</span></label>
              <div>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_1" value="Bureau" checked={formData.propertyTypes.includes("Bureau")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Kantoor
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_2" value="immeuble commercial ou locaux d'entreprise" checked={formData.propertyTypes.includes("immeuble commercial ou locaux d'entreprise")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Bedrijfspand of bedrijfsruimte
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_3" value="Ecole ou établissement d'enseignement" checked={formData.propertyTypes.includes("Ecole ou établissement d'enseignement")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  School of onderwijsinstelling
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_4" value="établissement de soins de santé ou pratique de soins de santé" checked={formData.propertyTypes.includes("établissement de soins de santé ou pratique de soins de santé")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Zorginstelling of zorgpraktijk
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_5" value="Garde d'enfants ou services de garde après l'école" checked={formData.propertyTypes.includes("Garde d'enfants ou services de garde après l'école")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Kinderdagverblijf of BSO
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_6" value="Espace commercial, magasin ou salle d'exposition" checked={formData.propertyTypes.includes("Espace commercial, magasin ou salle d'exposition")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Retail, winkelruimte of showroom
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_7" value="Installations sportives" checked={formData.propertyTypes.includes("Installations sportives")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Sportaccommodatie
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_8" value="VvE, porche ou cage d'escalier" checked={formData.propertyTypes.includes("VvE, porche ou cage d'escalier")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  VvE, portiek of trappenhuis
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_9" value="cabane de chantier ou de projet de construction" checked={formData.propertyTypes.includes("cabane de chantier ou de projet de construction")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Bouwproject of bouwkeet
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_10" value="lieu de l'événement ou lieu temporaire" checked={formData.propertyTypes.includes("lieu de l'événement ou lieu temporaire")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Evenement of tijdelijke locatie
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.75rem", cursor: "pointer" }}>
                  <input type="checkbox" name="property_11" value="Autre type de lieu" checked={formData.propertyTypes.includes("Autre type de lieu")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Ander type locatie
                </label>
              </div>
            </div>

            {/* Superficie */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Oppervlakte van de locatie (in m²)</label>
                <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "0.5rem" }}>Een globale inschatting is voldoende. Indien onbekend, kunt u dit aangeven</p>
                <input type="text" name="area" value={formData.area} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px" }} />
              </div>
              <div>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Gewenste schoonmaakfrequentie <span style={{ color: "red" }}>*</span></label>
                <select name="frequency" value={formData.frequency} onChange={handleInputChange} required style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5" }}>
                  <option value="">Selecteer</option>
                  <option value="Tous les jours (du lundi au vendredi)">Elke dag (van maandag tot en met vrijdag)</option>
                  <option value="Plusieurs fois par semaine">Meerdere keren per week</option>
                  <option value="Hebdomadaire">Wekelijks</option>
                  <option value="Une fois toutes les 2 semaines">Een keer per twee weken</option>
                  <option value="Une fois toutes les 4 semaines">Een keer per vier weken</option>
                  <option value="Nettoyage ponctuel">Ponctuele schoonmaak</option>
                  <option value="Nettoyage temporaire">Tijdelijke schoonmaak</option>
                  <option value="Sur demande">Op verzoek</option>
                  <option value="Inconnu ou à déterminer">Onbekend of nader te bepalen</option>
                </select>
              </div>
            </div>

            {/* Jours préférés */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem", marginBottom: "1.5rem" }}>
              <div>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Wat zijn uw voorkeursdagen?</label>
                <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Wij proberen uw voorkeursdagen te respecteren bij het kiezen van een schoonmaakagent die bij uw huis past. Indien dit niet mogelijk is, zullen wij op een ander(e) dag of dagen komen met u.</p>
                <div>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_1" value="Lundi" checked={formData.days.includes("Lundi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Maandag
                  </label>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_2" value="Mardi" checked={formData.days.includes("Mardi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Dinsdag
                  </label>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_3" value="Mercredi" checked={formData.days.includes("Mercredi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Woensdag
                  </label>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_4" value="Jeudi" checked={formData.days.includes("Jeudi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Donderdag
                  </label>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_5" value="Vendredi" checked={formData.days.includes("Vendredi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Vrijdag
                  </label>
                  <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                    <input type="checkbox" name="days_6" value="Samedi" checked={formData.days.includes("Samedi")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                    Zaterdag
                  </label>
                </div>
              </div>
              <div>
                <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Gewenste tijdvak voor de schoonmaak</label>
                <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Wij proberen uw voorkeursdagen te respecteren bij het kiezen van een schoonmaakagent die bij uw huis past. Indien dit niet mogelijk is, zullen wij op een ander(e) dag of dagen komen met u.</p>
                <select name="timeSlot" value={formData.timeSlot} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5" }}>
                  <option value="">Selecteer</option>
                  <option value="Nettoyage du soir">Avondschoonmaak</option>
                  <option value="Nettoyage de jour">Dagelijkse schoonmaak</option>
                  <option value="Nettoyage du matin">Ochtend schoonmaak</option>
                </select>
              </div>
            </div>

            {/* Heures de nettoyage */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Hoeveel schoonmaakuren worden momenteel gemiddeld per schoonmaakronde ingezet?</label>
              <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "0.5rem" }}>Indien u dit niet exact weet, volstaat een globale inschatting per schoonmaakronde.</p>
              <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Wij hanteren een minimum van 2,5 schoonmaakuren per ronde</p>
              <div>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_1" value="Plus de 20 heures" checked={formData.hours.includes("Plus de 20 heures")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Meer dan 20 uur per keer
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_2" value="16 à 20 heures" checked={formData.hours.includes("16 à 20 heures")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  16 tot 20 uur per keer
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_3" value="8 à 16 heures" checked={formData.hours.includes("8 à 16 heures")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  8 tot 16 uur per keer
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_4" value="4 à 8 heures" checked={formData.hours.includes("4 à 8 heures")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  4 tot 8 uur per keer
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_5" value="2,5 à 4 heures" checked={formData.hours.includes("2,5 à 4 heures")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  2,5 tot 4 uur per keer
                </label>
                <label style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", cursor: "pointer" }}>
                  <input type="checkbox" name="hours_6" value="Lieu inconnu ou nouveau" checked={formData.hours.includes("Lieu inconnu ou nouveau")} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                  Onbekend of nieuwe locatie
                </label>
              </div>
            </div>

            {/* Demandes supplémentaires */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Aanvullende schoonmaakwensen of bijzonderheden</label>
              <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Geef hier eventuele bijzonderheden of aanvullende wensen door die nog niet in het formulier zijn uitgevraagd, zoals specifieke ruimtes, aandachtspunten of extra werkzaamheden.</p>
              <textarea name="additionalDetails" value={formData.additionalDetails} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", minHeight: "120px" }}></textarea>
            </div>

            {/* Comment nous avez-vous trouvés */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Hoe heeft u ons gevonden?</label>
              <select name="howFound" value={formData.howFound} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5" }}>
                <option value="">Selecteer</option>
                <option value="Google">Google</option>
                <option value="Recommandation">Aanbeveling</option>
                <option value="Réseaux sociaux">Sociale media</option>
                <option value="Annuaire">Bedrijvengids</option>
                <option value="Autre">Anders</option>
              </select>
            </div>

            {/* Mot-clé */}
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>Op welk zoekwoord of welke prompt heeft u ons gevonden?</label>
              <p style={{ color: "#999", fontSize: "0.9rem", marginBottom: "1rem" }}>Uit welk zoekwoord of welke prompt heeft u ons gevonden? U kunt dit hier aangeven. Dit is optioneel.</p>
              <textarea name="keyword" value={formData.keyword} onChange={handleInputChange} style={{ width: "100%", padding: "0.75rem", border: "1px solid #ddd", borderRadius: "4px", minHeight: "80px" }}></textarea>
            </div>

            {/* Consentement */}
            <div style={{ marginBottom: "2rem", paddingBottom: "2rem", borderBottom: "1px solid #ddd" }}>
              <p style={{ color: "#666", fontSize: "0.9rem", marginBottom: "1rem" }}>
                Directschoon is toegewijd aan het beschermen en respecteren van je privacy, en we zullen je persoonlijke informatie alleen gebruiken om je account te beheren en om de producten en diensten te leveren waar je ons om hebt gevraagd. Van tijd tot tijd willen wij contact met je opnemen over onze producten en diensten, en andere inhoud die je interessant zou kunnen vinden. Als je ermee instemt dat wij contact met je opnemen, vink dan hieronder aan hoe je wilt dat wij contact met je opnemen:
              </p>
              <label style={{ display: "flex", alignItems: "center", marginBottom: "1rem", cursor: "pointer" }}>
                <input type="checkbox" name="acceptMessages" checked={formData.acceptMessages} onChange={handleInputChange} style={{ marginRight: "0.5rem" }} />
                <span>Ik ga ermee akkoord om andere berichten te ontvangen van Directschoon.</span>
              </label>
              <p style={{ color: "#666", fontSize: "0.9rem", marginBottom: "1rem" }}>
                Je kunt je op elk moment afmelden voor deze berichten. Bekijk ons privacybeleid voor meer informatie over hoe je af te melden, onze privacypraktijken en hoe we ons inzetten om je privacy te beschermen en respecteren.
              </p>
              <p style={{ color: "#666", fontSize: "0.9rem" }}>
                Door hieronder op verzenden te klikken, geef je toestemming aan Directschoon. om de hierboven ingediende persoonlijke informatie op te slaan en te verwerken om je van de gevraagde inhoud te voorzien.
              </p>
            </div>

            <button type="submit" disabled={loading} style={{ backgroundColor: loading ? "#ccc" : "#ff6b5b", color: "white", padding: "0.75rem 2rem", fontSize: "1rem", fontWeight: "bold", border: "none", borderRadius: "4px", cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Bezig met verzenden..." : "Verzenden"}
            </button>
          </form>
        </div>
      </div>

      {/* Modal de succès */}
      {showSuccessModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "2rem",
            maxWidth: "500px",
            width: "90%",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            position: "relative"
          }}>
            {/* Bouton X de fermeture */}
            <button
              onClick={closeSuccessModal}
              style={{
                position: "absolute",
                top: "1rem",
                right: "1rem",
                backgroundColor: "transparent",
                border: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
                color: "#666"
              }}
            >
              ✕
            </button>

            {/* Contenu du modal */}
            <div style={{ textAlign: "center", marginBottom: "2rem" }}>
              <div style={{
                fontSize: "3rem",
                marginBottom: "1rem"
              }}>
                ✅
              </div>
              <h2 style={{
                color: "#2c3e50",
                marginBottom: "1rem",
                fontSize: "1.5rem"
              }}>
                Uw aanvraag voor een offerte is succesvol verzonden!
              </h2>
              <p style={{
                color: "#666",
                fontSize: "1rem",
                marginBottom: "0"
              }}>
                Wij hebben uw aanvraag succesvol ontvangen en nemen binnenkort contact met u op om de details te bespreken.
              </p>
            </div>

            {/* Bouton Annuler */}
            <button
              onClick={closeSuccessModal}
              style={{
                width: "100%",
                padding: "0.75rem",
                backgroundColor: "#00c3c3",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontSize: "1rem",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Sluiten
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
